var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-0 left-0 h-full w-full items-center",staticStyle:{"pointer-events":"none"}},[_c('div',{staticClass:"demo rounded-lg font-bold opacity-50"},[_vm._v("KHUSUS DEMO")])])
}]

export { render, staticRenderFns }